import type { TTrackingConfig } from './types';

export const TRACKED_ACTIONS = {
  // for download links:
  DOWNLOAD_LINKS_RENDERED_RETRY_UI: 'DOWNLOAD_LINKS_RENDERED_RETRY_UI',
  USER_RETRIES_GET_LINKS: 'USER_RETRIES_GET_LINKS',
  // for audiotrack selector:
  OPEN_AUDIOTRACKS_POPOVER: 'OPEN_AUDIOTRACKS_POPOVER',
  CLOSE_AUDIOTRACKS_POPOVER: 'CLOSE_AUDIOTRACKS_POPOVER',
  AUDIOTRACKS_SELECTOR_RENDERED_UI: 'AUDIOTRACKS_SELECTOR_RENDERED_UI',
  AUDIOTRACKS_SELECTOR_RENDERED_RETRY_UI: 'AUDIOTRACKS_SELECTOR_RENDERED_RETRY_UI',
  USER_SELECTED_AUDIOTRACK: 'USER_SELECTED_AUDIOTRACK',
  USER_RETRIES_GET_AUDIOTRACKS: 'USER_RETRIES_GET_AUDIOTRACKS',
};
export const TRACKED_ERRORS = {
  VIDEO_ID_MISSING: 'VIDEO_ID_MISSING',
  FETCH_DL_LINKS_FAILED: 'FETCH_DL_LINKS_FAILED',
  FETCH_CLIP_FAILED: 'FETCH_CLIP_FAILED',
  FETCH_AUDIOTRACKS_FAILED: 'FETCH_AUDIOTRACKS_FAILED',
  FETCH_CLIP_METADATA_FAILED: 'FETCH_CLIP_METADATA_FAILED',
  VIDEO_VERSION_ID_MISSING: 'VIDEO_VERSION_ID_MISSING',
  UI_NO_LINKS_TO_SHOW: 'UI_NO_LINKS_TO_SHOW',
  UI_USED_FALLBACK_LINKS: 'UI_USED_FALLBACK_LINKS',
  FAILED_VIDEO_TAGGING: 'FAILED_VIDEO_TAGGING',
  AUDIOTRACK_MISSING_UPLOAD: 'AUDIOTRACK_MISSING_UPLOAD',
};

export const APP_TYPE = 'downloads-modal';

export const trackingConfig: TTrackingConfig = {
  APP_TYPE: APP_TYPE,
  ALLOW_AUDIOTRACK_SELECTOR: null,
  IS_AB_TEST: null,
  USER_ID: null,
  USER_LOCALE: null,
  LOG_ERRORS_TRACKED: 0,
  LOG_ERRORS_LIMIT: 50,
  SESSION_ID: null,
  STARTED_AT: Date.now(),
  PAGE_NAME: null,
  MODAL_LOCATION: null,
  VIDEO_ID: null,
};
